import { useEffect } from "react";
import { useLogoutHook } from "../../hooks/useLogoutHook";
import { useParams } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import NewDCGAutomationAccount from "../NewAccountWizard/NewDCGAutomationAccount";
import { OldOnboarding } from "../../constants/onboardingVersions";

const Logout = () => {
    const { redirectUrl } = useParams();
    const auth = useAuth();
    const { logout } = useLogoutHook(`/${OldOnboarding}/${redirectUrl}`);
    useEffect(() => {
        if (auth.isAuthenticated) {
            logout();
        }
    }, [auth, logout]);
    if (!auth.isAuthenticated) {
        return <NewDCGAutomationAccount />
    }
    return;
}

export default Logout;